module.exports = __webpack_public_path__ + "static/media/ID.6b254ad7.svg";